<template>
    <b-row class="carrito-entradas-container mb-3" v-if="entradas?.length > 0">
        <b-col v-for="(entrada, index) in entradas" :key="index" cols="12">
            <b-row>
                <b-col cols=12 class="cart-event-title">
                    <h5>{{ entrada.evento }}</h5>
                </b-col>
                <b-col cols="12" class="mb-2">
                    <span>
                        <i class="fa fa-calendar" aria-hidden="true"></i> {{ getDia(entrada.fecha) }}
                    </span>
                    <span class="carrito-hora">
                        <i class="fa fa-clock" aria-hidden="true"></i> {{ getHora(entrada.fecha) }}
                    </span>
                </b-col>
                <b-col cols="12" v-for="(item, subIndex) in entrada.items" :key="subIndex">
                    <b-row class="tickets-container">
                        <b-col cols="12" class="ticket-container">
                            <div>
                                <div v-if="item.asiento" class="asiento-text">
                                    {{ (item.asiento?.region_name ? (item.asiento?.region_name + ' | ') : '') + $t('carrito.fila') + ': ' + item.asiento?.row + ' | ' + $t('carrito.asiento') + ': ' + item.asiento?.seat }}
                                </div>
                                <div v-if="item.plaza" class="asiento-text">
                                    {{ (item.plaza?.region_name ? (item.plaza?.region_name + ' | ') : '') + $t('carrito.fila') + ': ' + item.plaza?.fila + ' | ' + $t('carrito.asiento') + ': ' + item.plaza?.butaca }}
                                </div>
                                <div v-if="!item.asiento && !item.plaza" class="asiento-text">
                                    {{ $t('carrito.sin_numerar') }}
                                </div>
                                <div>
                                    {{ item.entrada.descripcion }}: {{ item.entrada.precio | formatear_precio }}
                                </div>
                            </div>
                            <div>
                                <i class="fa fa-trash icon" aria-hidden="true" @click="eliminarProducto(item.id)"></i>
                            </div>
                        </b-col>
                        <b-col cols="12" class="mt-1" v-if="subIndex != entrada.items.length - 1">
                            <hr>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" class="mt-2" v-if="index != entrada.items.length">
                    <hr>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
export default {
    props: {
        entradas: {
            type: Array,
            required: true
        }
    },
    methods: {
        getDia(fecha) {
            return moment(fecha).format('DD-MM-YYYY');
        },
        getHora(fecha) {
            return moment(fecha).format('HH:mm');
        },
        eliminarProducto(item_id) {
            this.$emit('eliminarProducto', item_id);
        }
    }
}
</script>

<style scoped>
.carrito-entradas-container {
    background-color: #EDEDED;
    padding: 20px 40px;
}
.carrito-hora{
    margin-left: 10px;
}
.cart-event-title {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.tickets-container {
    margin-top: 5px;
    padding-left: 30px;
}
.ticket-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: grey;
    font-size: 14px;
}
hr {
    margin-top: 10px;
    margin-bottom: 10px;
}
.hr-event {
    margin-top: 30px;
    margin-bottom: 30px;
    border-top: 2px solid rgba(0, 0, 0, 0.1);
}

.icon {
    cursor: pointer;
}
</style>